import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import ServiceCard from '../../../../components/user/maintain/repaircard/RepairCard';

// import RepairCard from '../../../../../components/user/maintain/repaircard/RepairCard.js';
import { FaWrench, FaCog, FaClock, FaTachometerAlt, FaTools, FaCheckCircle } from 'react-icons/fa';
import '../../../../assets/css/user/maintainance/repairservices/RepairServices.css';

const Repair = () => {
  const services = [
    {
      id: 1,
      icon: <FaWrench />,
      title: 'Diesel Engine Repair',
      description: 'We provide expert repair and maintenance services for diesel engines used in tractors and heavy agricultural equipment. Our service ensures better fuel efficiency, reduced breakdowns, and reliable performance during critical farming operations.'
    },
    {
      id: 2,
      icon: <FaCog />,
      title: 'Construction Machinery Repair',
      description: 'We offer complete repair solutions for heavy-duty machinery used in agricultural and construction activities. Our technicians quickly diagnose faults and ensure equipment is restored to working condition with minimal downtime.'
    },
    {
      id: 3,
      icon: <FaClock />,
      title: 'Powertrain Component Repair',
      description: 'Our specialists handle repair and maintenance of powertrain components including transmission systems, gearboxes, and drive shafts. This ensures smooth power transfer and improves the overall efficiency of your machinery.'
    },
    {
      id: 4, 
      icon: <FaTachometerAlt />,
      title: 'Hydraulic Machinery Repair',
      description: 'We provide professional repair services for hydraulic systems used in loaders, lifters, and irrigation equipment. Our service ensures proper pressure control, smooth operation, and long-lasting performance in field conditions.'
    },
    // {
    //   id: 5,
    //   icon: <FaTools />,
    //   title: 'Equipment Maintenance',
    //   description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore. Lorem ipsum dolor sit amet, consectetur adipiscing elit.'
    // },
    // {
    //   id: 6,
    //   icon: <FaCheckCircle />,
    //   title: 'Quality Inspection',
    //   description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore. Lorem ipsum dolor sit amet, consectetur adipiscing elit.'
    // }
  ];

  const handleServiceClick = (title) => {
    console.log('Service clicked:', title);
    // Yahan aap navigate, modal open, ya filter kar sakte hain
  };

  // Divide services into 2 rows of 3 cards each
  const firstRow = services.slice(0, 4);
  // const secondRow = services.slice(4, 6);

  return (
    <section className="services-section">
      <Container>
        {/* Section Header */}
        <div className="services-header">
          {/* <div className="header-background-text">REPAIRSERVICES</div> */}
          <h2 className="services-main-heading">
            REPAIR
            <br />
            SERVICES
          </h2>
          <div className="services-heading-underline"></div>
        </div>

        {/* First Row - 3 Cards */}
        <Row className="services-row mb-4">
          {firstRow.map((service) => (
            <Col 
              key={service.id} 
              lg={3} 
              sm={6} 
              xs={12}
              className="service-card-col"
            >
              <ServiceCard
                service={service}
                onClick={handleServiceClick}
              />
            </Col>
          ))}
        </Row>

        {/* Second Row - 3 Cards */}
        {/* <Row className="services-row">
          {secondRow.map((service) => (
            <Col 
              key={service.id} 
              lg={4} 
              md={6} 
              sm={12} 
              className="service-card-col"
            >
              <ServiceCard
                service={service}
                onClick={handleServiceClick}
              />
            </Col>
          ))}
        </Row> */}
      </Container>
    </section>
  );
};

export default Repair;